// In the OE deployment an OE's owner is its CISO. Locale files and saved table
// configurations still carry "Owner", so OE-level owner labels override both.
const OE_PROJECT_NAME = "OE";
const CISO_LABEL = "CISO";

export function getOeOwnerLabel(
  projectName: string | undefined,
  fallback: string
): string {
  return projectName === OE_PROJECT_NAME ? CISO_LABEL : fallback;
}
